// import { wechatArticleService, wechatCircleService} from './instance.js'
import {createNewGatwaySign, createNewGatwaySignWx} from '@/utils/getSignHeader.js'
import { wechatDomainQLAPP, wechatDomainQL } from './instance.js'

export const transformRequest = [(data) => {
  let ret = ''
  for (let it in data) {
    if(data.hasOwnProperty(it)) {
      ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    }
  }
  ret = ret.slice(0, -1)
  return ret
}]

//获取资讯详情
export const getNewsContent = async (newsId, appCode, token = '') => {
  let params = {newsId, applicationCode: appCode}
  // let headers = getSignHeader(params)
  // return await wechatArticleService.get(`${appCode}/news/content`, {params, headers})
  let headers = createNewGatwaySign(params, 'get')
  headers.token = token
  const res =  await wechatDomainQLAPP.get(`/rjhy-news/api/1/gw/news/content`, { params, headers })
  return res
}

export const activeNewsReadCount = async (newsId, appCode) => {
  let params = {newsId, applicationCode: appCode}
  // let headers = getSignHeader(params)
  // return await wechatArticleService.get(`${appCode}/news/hitCount/application`, {
  //   params, headers
  // })
  let headers = createNewGatwaySign(params, 'get')
  const res =  await wechatDomainQLAPP.get(`/rjhy-news/api/1/gw/news/hitCount/application`, { params, headers })
  return res
}

//获取评论列表
export const getNewsCommentsList = async (newsId, token) =>{
  let params =  {
    newsId, token, pageSize: 99, pageNo: 1, platformSelect: 1 //platformselect留言置顶开关1为开
  }
  // let headers = getSignHeader(params)
  // return await wechatCircleService.get(`/review/list/${appCode}`, {
  //   params, headers
  // })
  let headers = createNewGatwaySign(params, 'get')
  headers.token = token
  const res =  await wechatDomainQLAPP.get(`/rjhy-circle/api/1/review/list/gw`, { params, headers })
  return res
}

//获取资讯动态
export const getNewsDetail = async (newsId, token) => {
  let params = {newsId,token}
  // let headers = getSignHeader(params)
  // return await wechatCircleService.get(`/news/customer/news/detail/${appCode}`, {
  //   params, headers
  // })
  let headers = createNewGatwaySign(params, 'get')
  headers.token = token
  const res =  await wechatDomainQLAPP.get(`/rjhy-circle/api/1/news/customer/news/detail/gw`, { params, headers })
  return res
}

//评论文章
// http://test-wechat1.9fzt.cn/wechat-article-common/index.html?temp_token=5fef99816ecf43de973cbf19983e9c25&key=wechat-common-jfql-xxj&channel_id=gzh_jfzt&page_source=wechat_main_page#/launcher-article/04a872e8598eef3fbda2973e0e63760e
export const submitNewsComment = async (content, newsId, uid, appCode, columnCodes, serverId) =>{
  let params = {content, newsId, token: uid, platform: appCode, column: columnCodes, serverId}
  // let headers = getSignHeader(params)
  // const res =  await wechatCircleService.post(`/review/customer/reviews/${appCode}`, params, {transformRequest, headers})
  // return res.data
  let headers = createNewGatwaySign(params, 'post', true)
  headers.token = uid
  headers['Content-Type'] = 'application/x-www-form-urlencoded'
  const res =  await wechatDomainQLAPP.post(`/rjhy-circle/api/1/review/customer/reviews/gw`, params, { transformRequest: transformRequest, headers })
  return res.data
}

//点赞文章
export const supportArticle = async (newsId, token, appCode, serverId) => {
  let params =  {
    newsId, token, serverId
  }
  // let headers = getSignHeader(params)
  // return await wechatCircleService.post(`/review/customer/support/news/${appCode}`, params, {transformRequest,headers})
  let headers = createNewGatwaySign(params, 'post', true)
  headers.token = token
  headers['Content-Type'] = 'application/x-www-form-urlencoded'
  const res =  await wechatDomainQLAPP.post(`/rjhy-circle/api/1/review/customer/support/news/gw`, params, { transformRequest: transformRequest, headers })
  return res
}

//取消点赞文章
export const unSupportArticle = async (newsId, uid, appCode, serverId) => {
  let params =  {
    newsId, token: uid, serverId
  }
  // let headers = getSignHeader(params)
  // return await wechatCircleService.post(`/review/customer/unSupport/news/${appCode}`, params, {transformRequest,headers})
  let headers = createNewGatwaySign(params, 'post', true)
  headers.token = uid
  headers['Content-Type'] = 'application/x-www-form-urlencoded'
  const res =  await wechatDomainQLAPP.post(`/rjhy-circle/api/1/review/customer/unSupport/news/gw`, params, { transformRequest: transformRequest, headers })
  return res
}

// http://test-wechat1.9fzt.cn/wechat-article-common/index.html?temp_token=8081a9ff8bf14a129643f453ec2e39c5&key=wechat-common-jfql-xxj&channel_id=gzh_jfzt&page_source=wechat_main_page#/launcher-article/cls_1419
export const getNewsArticles = async (columnCodes, appCode, token) => {
  let params =  {
    columnCodes, appCode
  }
  // let headers = getSignHeader(params)
  // return await wechatArticleService.get(`${appCode}/news/listWithColumn`, {
  //   params, headers
  // })
  let headers = createNewGatwaySign(params, 'get')
  headers.token = token
  const res =  await wechatDomainQLAPP.get(`/rjhy-news/api/1/huixg/news/listWithColumn`, { params, headers })
  return res
}


export const getArticleList = async(params) => {
  // let headers = getSignHeader(params)
  // return await wechatArticleService.get(`${params.appCode}/news/list`, { params, headers })
  let headers = createNewGatwaySignWx(params, 'get')
  headers.token = params.token
  const res =  await wechatDomainQL.get(`/rjhy-news/api/1/gw/news/list`, { params, headers })
  return res
}

export const getSubjectColumnList = async(appCode, params) => {
  // let headers = getSignHeader(params)
  // const {data} =  await wechatArticleService.get(`${appCode}/column/subject`, { params, headers })
  // return data.data
  let headers = createNewGatwaySignWx(params, 'get')
  const {data} =  await wechatDomainQL.get(`/rjhy-news/api/1/gw/column/subject`, { params, headers })
  return data.data
}

export const getSubject = async(appCode, params) => {
  // let headers = getSignHeader(params)
  // const {data} =  await wechatArticleService.get(`${appCode}/subject/detail`, { params, headers })
  // return data.data
  let headers = createNewGatwaySign(params, 'get')
  const {data} =  await wechatDomainQLAPP.get(`/rjhy-news/api/1/gw/subject/detail`, { params, headers })
  return data.data
}